// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as GemWingExtended } from '../../../assets/icons/extended/entities/gem-wing.svg?react';
import { createIcons } from '../../Icon';
const GemWingIcon = /* @__PURE__ */ createIcons('GemWing', {
    extended: GemWingExtended
});
GemWingIcon.supportedTypes = ['extended'];
GemWingIcon.category = 'entities';
export default GemWingIcon;
